import { render, staticRenderFns } from "./TranslatableFields.vue?vue&type=template&id=425f874f&scoped=true&"
import script from "./TranslatableFields.vue?vue&type=script&lang=js&"
export * from "./TranslatableFields.vue?vue&type=script&lang=js&"
import style0 from "./TranslatableFields.vue?vue&type=style&index=0&id=425f874f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425f874f",
  null
  
)

export default component.exports